import { Children, isValidElement, type ReactNode } from 'react';

import type { VirtualAutocompleteRow } from '@features/autocompleteVirtualization/types';

export const getVirtualAutocompleteListElements = (
  children: ReactNode = null
): VirtualAutocompleteRow[] =>
  Children.toArray(children).filter((node) => isValidElement(node));
